"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _assets = require("../assets");

var _antd = require("antd");

require("antd/dist/antd.css");

var _IndexModule = _interopRequireDefault(require("./Index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Header(_ref) {
  var labelLogo = _ref.labelLogo,
      middleComponent = _ref.middleComponent,
      rightComponent = _ref.rightComponent;

  var _useState = (0, _react.useState)("180px"),
      _useState2 = _slicedToArray(_useState, 2),
      logoSize = _useState2[0],
      setLogoSize = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      if (window.innerWidth > 500) setLogoSize("180px");else setLogoSize("120px");
    };

    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerContainer
  }, /*#__PURE__*/_react["default"].createElement(_antd.Row, null, /*#__PURE__*/_react["default"].createElement(_antd.Col, {
    span: "24"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Row, {
    align: "middle"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Col, {
    span: middleComponent ? "8" : "12"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerLeftSide
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerLogoContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerLogo
  }, /*#__PURE__*/_react["default"].createElement(_assets.Logo, {
    width: logoSize,
    heigth: logoSize
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerTitle
  }, /*#__PURE__*/_react["default"].createElement("h3", null, labelLogo))))), middleComponent && /*#__PURE__*/_react["default"].createElement(_antd.Col, {
    span: "8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerMiddleSide
  }, middleComponent)), /*#__PURE__*/_react["default"].createElement(_antd.Col, {
    span: middleComponent ? "8" : "12"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _IndexModule["default"].headerRightSide
  }, rightComponent))))));
}

var _default = Header;
exports["default"] = _default;